<template>
<v-app>
    <v-container class="mt-1" fluid>
        <v-row class="mx-0">
            <v-col cols="3">
                <v-card>
                    <v-card-title>
                        <v-btn @click="goToBmci()" class="mb-4" color="primary" block=true>Voir les offres BMCI</v-btn>
                        Simulateur Crédit
                    </v-card-title>
                    <v-card-text>
                        <FormSimulateurCredit :tarif="tarif" :index="index" :periodeId="periodeId" type="VIVALIS"></FormSimulateurCredit>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-carousel hide-delimiter-background height="auto" show-arrows-on-hover v-model="index">
                    <v-carousel-item>
                        <LarParticuliers></LarParticuliers>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaParticuliers></LoaParticuliers>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaEntreprises></LoaEntreprises>
                    </v-carousel-item>
                </v-carousel>
            </v-col>

        </v-row>
    </v-container>
</v-app>
</template>

<script>
import LarParticuliers from './larParticuliers.vue'
import LoaEntreprises from './loaEntreprises.vue'
import LoaParticuliers from './loaParticuliers.vue'
import FormSimulateurCredit from './../formSimulateur.vue'
export default {
    name: "VivalisAccueil",
    data() {
        return {
            index: 0
        }
    },
    props: ["tarif", "periodeId"],
    mounted() {},
    methods: {
      goToBmci: function () {
        this.$router.push({
          name: "BmciAccueil",
          params: {
            tarif: this.tarif,
            periodeId: this.periodeId
          }
        })
      },
    },
    components: {
        LarParticuliers,
        LoaEntreprises,
        LoaParticuliers,
        FormSimulateurCredit
    }
}
</script>
